"use strict";

// parts
import "./parts/_tracking.js";
import "./parts/_dynamic-phone.js";
import "./parts/_accordion.js";
import "./parts/_bottomMenu.js";
import "./parts/_drawer.js";
import "./parts/_fixed-viewport.js";
import "./parts/_modal.js";
import "./parts/_compareTableModal.js";
import "./parts/_flags.js";
import "./parts/_validation.js";
import "./parts/_contact-form.js";
import "./parts/_contact-tel.js";
import "./parts/_bottomMenuForm.js";
